import { generateRandomGuid } from '../../../../global/utils/utils';
export class AddressSearchService {
  constructor(baseUrl, subscriptionKey, isMailingAddress, includeUnserviceable, includePostOfficeBox) {
    this.baseUrl = baseUrl;
    this.httpHeaders = {
      'Content-Type': 'application/json; charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
      'Ocp-Apim-Subscription-Key': subscriptionKey,
      'Correlation-Id': generateRandomGuid(),
      'Api-Version': 'v2'
    };
    this.isMailingAddress = isMailingAddress;
    this.includeUnserviceable = includeUnserviceable;
    this.includePostOfficeBox = includePostOfficeBox;
  }
  /**
   * Returns an Promise for the HTTP GET request for the JSON resource.
   * Get the data modal for the address searching.
   * @return {DataModel} The Promise for the HTTP request.
   */
  async getAddressList(query) {
    let urlParams = '';
    if (this.includePostOfficeBox || this.includeUnserviceable) {
      urlParams = `&excludeUnserviceable=${!this.includeUnserviceable}&excludePostOfficeBox=${!this.includePostOfficeBox}`;
    }
    else if (this.isMailingAddress) {
      urlParams = '&excludeUnserviceable=false&excludePostOfficeBox=false';
    }
    const urlPathAndParams = this.baseUrl + `/addresses/search/suggest?query=${query}&maxResults=10` + urlParams;
    try {
      const response = await fetch(urlPathAndParams, {
        method: 'GET',
        headers: this.httpHeaders,
        credentials: 'include'
      });
      handleErrors(response);
      const data = await response.json();
      return data;
    }
    catch (e) {
      throw new Error(e);
    }
  }
  /**
   * Returns an promise for the HTTP GET request for the JSON resource.
   * Get the addressDetails for address selected from the list.
   * @return {QasResponse} The promise for the HTTP request.
   */
  async getAddressDetails(id) {
    const urlParams = this.baseUrl + `/addresses/search/select?Id=${id}`;
    try {
      const response = await fetch(urlParams, {
        method: 'GET',
        headers: this.httpHeaders,
        credentials: 'include'
      });
      handleErrors(response);
      const data = await response.json();
      return data;
    }
    catch (e) {
      throw new Error(e);
    }
  }
}
function handleErrors(response) {
  if (!response.ok) {
    throw new Error(response.status.toString());
  }
  return response;
}
